import styled from 'styled-components'

export const CheckboxContainer = styled.label`
  max-width: 50px;

  input[type='checkbox'] {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }

  span {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 18px;
    height: 18px;
    background: ${({ theme }) => theme.zds.colors.neutral1000};
    border: 1px solid ${props => props.theme.colors.colorb9c2ce};
    transition: all 0.3s ease;

    div {
      width: 11px;
      height: 11px;
      background: ${props => props.theme.colors.color378ff7};
      transform: scale(0.8);
      opacity: 0;
      transition: all 0.3s ease;
    }
  }

  input[type='checkbox']:checked + span {
    border: 1px solid ${props => props.theme.colors.color378ff7};

    div {
      transform: scale(1);
      opacity: 1;
    }
  }

  input[type='checkbox']:focus-visible + span {
    border: 1px solid ${props => props.theme.colors.color378ff7};
  }

  input[type='checkbox']:hover + span {
    border: 1px solid ${props => props.theme.colors.color378ff7};
  }
`
